import EasyMDE from "easymde";

export default {
  mounted() {
    this.input = this.el.querySelector("textarea")
    this.editor = new EasyMDE({
      element: this.input,
      // fullscreen: true
    });

    this.editor.codemirror.on("change", () => {
      console.log("change", this.editor.value())
      this.pushEvent("validate", { page: { body: this.editor.value() } })
    });
  },
  updated() {
    console.log("editor updated", this.editor.value());
    this.input.innerText = this.editor.value()
  },
}
